import * as React from 'react';

import type { QueryResult } from '@apollo/client';

import type { TaskResponse } from 'common/components/TasksWidget/queries';

import type { SourceHelpers } from '../Source';
import Source from '../Source';
import type { SubscribedTasksResponse } from './queries';
import { getSubscribedTasks } from './queries';
import { subscribedTaskCreated, subscribedTaskUpdated } from './subscriptions';

export interface SubscribedTaskSourceProps {
  children: (
    entities: TaskResponse[],
    helpers: SourceHelpers<TaskResponse>,
    queryResult: QueryResult<SubscribedTasksResponse>
  ) => React.ReactNode;
}

class SubscribedTaskSource extends React.PureComponent<SubscribedTaskSourceProps> {
  selectEntityId = (task: TaskResponse) => task.id;
  selectSyncOn = (task: TaskResponse) => new Date(task.updatedAt);
  selectEntities = (response?: SubscribedTasksResponse) => response?.me?.tasks || [];
  selectStaleEntities = (response?: SubscribedTasksResponse) => response?.me?.sync || [];

  render() {
    return (
      <Source<TaskResponse, SubscribedTasksResponse>
        name="SubscribedTaskSource"
        selectEntities={this.selectEntities}
        selectStaleEntities={this.selectStaleEntities}
        selectEntityId={this.selectEntityId}
        selectSyncOn={this.selectSyncOn}
        query={getSubscribedTasks}
        subscriptions={{ create: [{ query: subscribedTaskCreated }], update: { query: subscribedTaskUpdated } }}
      >
        {(entities, helpers, queryResult) => this.props.children(entities, helpers, queryResult)}
      </Source>
    );
  }
}

export default SubscribedTaskSource;
